import type { ProductCost } from '../../api/common/model/customer';
import type { DiscountState } from './discount-types';

type SiteLevelDiscounts = 'LEGACY' | 'ASK_OBSERVE_BUNDLE_DEDUCTION';

function hasDiscount(
  costs: ProductCost[] | null | undefined,
  siteId: string,
  type: SiteLevelDiscounts,
): boolean {
  return (
    costs
      ?.filter((productCosts) => productCosts.entity.entityIdentifier === siteId)
      .some((productCosts) =>
        productCosts.componentCosts.some(
          (componentCost) => componentCost.componentIdentifier === type,
        ),
      ) ?? false
  );
}

export const hadDiscountForComponentId =
  (type: SiteLevelDiscounts) =>
  (
    siteId: string,
    currentCosts: ProductCost[] | null | undefined,
    futureCosts: ProductCost[] | null | undefined,
  ): DiscountState => {
    const hasNowDiscount = hasDiscount(currentCosts, siteId, type);
    const willHaveDiscount = hasDiscount(futureCosts, siteId, type);

    if (hasNowDiscount && !willHaveDiscount) {
      return 'removed';
    }

    if (willHaveDiscount) {
      return 'applied';
    }

    return null;
  };

export const getBundleDiscount = hadDiscountForComponentId('ASK_OBSERVE_BUNDLE_DEDUCTION');

export const getLegacyDiscount = hadDiscountForComponentId('LEGACY');
